<template>
  <div>
    <ContentWrap title="黑名单">
      <el-form :inline="true" class="mb8" @submit.prevent>
        <el-form-item label="直播间">
          <LiveRoomIdSelect v-model="queryParams.roomId" select-class="!w-260px" />
        </el-form-item>
        <el-form-item label="会员用户">
          <LiveMemberUserSelect v-model="queryParams.memberId" select-class="!w-260px" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery"><Icon icon="ep:search" />查询</el-button>
          <el-button @click="resetQuery"><Icon icon="ep:refresh" />重置</el-button>
        </el-form-item>
      </el-form>
    </ContentWrap>

    <ContentWrap>
      <el-table v-loading="loading" :data="list" border>
        <el-table-column label="编号" prop="id" width="80" />
        <el-table-column label="房间ID" prop="roomId" min-width="120" />
        <el-table-column label="用户ID" prop="memberId" min-width="120" />
        <el-table-column
          label="创建时间"
          prop="createTime"
          min-width="180"
          :formatter="dateFormatter"
        />
        <el-table-column label="操作" width="120" fixed="right">
          <template #default="scope">
            <el-button
              link
              type="danger"
              @click="handleDelete(scope.row)"
              v-hasPermi="['live:blacklist:delete']"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <pagination
        v-show="total > 0"
        :total="total"
        v-model:page="queryParams.pageNo"
        v-model:limit="queryParams.pageSize"
        @pagination="getList"
      />
    </ContentWrap>
  </div>
</template>

<script setup lang="ts">
import { dateFormatter } from '@/utils/formatTime'
import { ref, reactive, onMounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { pageBlacklist, deleteBlacklist } from '@/api/live/blacklist'
import LiveRoomIdSelect from '@/views/live/components/LiveRoomIdSelect.vue'
import LiveMemberUserSelect from '@/views/live/components/LiveMemberUserSelect.vue'

const loading = ref(false)
const list = ref<any[]>([])
const total = ref(0)

const queryParams = reactive({
  pageNo: 1,
  pageSize: 10,
  roomId: undefined as number | undefined,
  memberId: undefined as number | undefined
})

const getList = async () => {
  loading.value = true
  try {
    const data: any = await pageBlacklist(queryParams)
    list.value = data.list || []
    total.value = data.total || 0
  } finally {
    loading.value = false
  }
}

const handleQuery = () => {
  queryParams.pageNo = 1
  getList()
}

const resetQuery = () => {
  queryParams.roomId = undefined
  queryParams.memberId = undefined
  handleQuery()
}

const handleDelete = (row: any) => {
  ElMessageBox.confirm('确认将该用户移出黑名单吗？', '提示', { type: 'warning' }).then(async () => {
    await deleteBlacklist(row.id)
    ElMessage.success('删除成功')
    getList()
  })
}

onMounted(() => {
  getList()
})
</script>
